import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const PageNumberStyle = styled.div`
    {
        display: inline-flex;
        align-items:center;
        justify-content: flex-start;
        height: 29px;
        width: 29px;
        box-sizing: border-box;
        margin: 0 0  0 5px;

        a {
            margin: 5px;
            width: 9px;
            font-family: Helvetica Neue;
            font-size: 19px;
            font-weight: 500;
            padding: 5px;
            color: #818181;
            text-decoration: underline;
            margin: 0;
            box-sizing: border-box;

        }

        .innerDiv {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 3px;
        }


        .active {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            margin: 0;
            border-radius: 50%;
            color: white;
            display: flex;
            justify-content: center;
            text-decoration: none;
            align-items: center;
            background-color: #00b4b3;
        }

    }
`

const PageNumber = (props) => (
    <PageNumberStyle>
        <Link
            className="pageNumber"
                to={`/${props.category}/${props.number === 1 ? "/" : props.number}`}
                activeClassName="active"
            >
            <div className="innerDiv">
                {props.number}
            </div>
        </Link>
    </PageNumberStyle>
  );

  export default PageNumber;

